import { COLOR_SCHEME_DARK, COLOR_SCHEME_LIGHT, VARIANT_NAMES } from "../../THEME_BASE";
import opacify from "../../utils/opacify";
import { contrastingColor } from "../../utils";
const buttonColors = (colorScheme, colors, primaryShade) => {
  const customColors = {
    gray: {
      [COLOR_SCHEME_LIGHT]: opacify(colors.gray[2], 0.4),
      [COLOR_SCHEME_DARK]: colors.gray[3]
    }
  };
  return Object.fromEntries(
    VARIANT_NAMES.map((variantName) => {
      var _a, _b;
      const background = (_b = (_a = customColors[variantName]) == null ? void 0 : _a[colorScheme]) != null ? _b : colors[variantName][primaryShade];
      return [variantName, { background, color: contrastingColor(background) }];
    })
  );
};
export default buttonColors;
